// extracted by mini-css-extract-plugin
module.exports = {"survey":"Questionnaire_style_survey__1zKYe"};